/* istanbul ignore file */
/* It's not possible to fill VGS fields in Cypress */
import { useField, useFormikContext } from 'formik'
import { useEffect } from 'react'

import { useTranslation } from '@lib/i18n'
import { CheckoutFormData } from '@pages/Checkout/hooks/useInitialFormValues'

export const useCheckPaymentState = (fieldName: string, isEnabled: boolean) => {
  const { t } = useTranslation()

  const { isSubmitting, isValidating } = useFormikContext<CheckoutFormData>()

  const [_, meta, helpers] = useField(fieldName)

  useEffect(() => {
    !meta.value && isEnabled && helpers.setError(t('checkCard.error'))
  }, [isEnabled, helpers, isSubmitting, isValidating, meta.value, t])

  return {
    isPaymentChecked: meta.value,
    cardError: meta.error,
    setCheckStatus: helpers.setValue,
    setCardError: helpers.setError,
  }
}
